import { Model } from "pinia-orm";

export default class Site extends Model {
  static entity = "sites";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      siteAccess: this.attr(null),
      constraints: this.attr([]),
      sitePhotos: this.attr([]),
      project: this.attr(null),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      immediateDangers: this.attr([]),
      visitSection: this.number(0),
      overallEnvironment: this.attr([]),
      isNonWaterproofedSurfaces: this.boolean(false),
      surfacesNature: this.attr([]),
      isStoragePresent: this.boolean(false),
      storageNature: this.string(""),
      locationPlan: this.attr(null),
      locationPlanName: this.string(""),
      locationPlanSize: this.string(""),
      centerLatitude: this.attr(null),
      centerLongitude: this.attr(null),
      cartographyElements: this.attr([]),
    };
  }
}
